import { defineComponent as s, createBlock as n, openBlock as l, createSlots as p, withCtx as r, renderSlot as a, createElementVNode as g, renderList as P, normalizeProps as m, guardReactiveProps as w } from "vue";
import b from "./Layout.vue.js";
const S = ["innerHTML"], B = /* @__PURE__ */ s({
  __name: "ApiGuideStatic",
  props: {
    activePage: {},
    editorViewportId: {},
    showSidebar: { type: Boolean },
    footerBelowSidebar: { type: Boolean },
    sidebar: {},
    headings: {},
    htmlContent: {},
    isLoaded: { type: Boolean },
    isPaid: { type: Boolean }
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(f) {
    return (e, o) => (l(), n(b, {
      activePage: e.activePage,
      editorViewportId: e.editorViewportId,
      footerBelowSidebar: e.footerBelowSidebar,
      headings: e.headings,
      isLoaded: e.isLoaded,
      isPaid: e.isPaid,
      showSidebar: e.showSidebar,
      sidebar: e.sidebar,
      staticToc: !0,
      onGoToNextPage: o[0] || (o[0] = (i) => e.$emit("goToNextPage", i)),
      onGoToPrevPage: o[1] || (o[1] = (i) => e.$emit("goToPrevPage", i))
    }, p({
      "editor-content": r(() => [
        a(e.$slots, "mdx-content", {}, () => [
          g("div", {
            class: "active editor-content editor-static",
            innerHTML: e.htmlContent
          }, null, 8, S)
        ])
      ]),
      _: 2
    }, [
      P(e.$slots, (i, t) => ({
        name: t,
        fn: r((d) => [
          a(e.$slots, t, m(w(d || {})))
        ])
      }))
    ]), 1032, ["activePage", "editorViewportId", "footerBelowSidebar", "headings", "isLoaded", "isPaid", "showSidebar", "sidebar"]));
  }
});
export {
  B as default
};
